import { axiosInstance } from './api';
import { ROUTES } from './http-common';

export const report = async (param: any) => {
  const response = await axiosInstance.post(ROUTES.REPORT, param);
  return response.data;
};
